import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroOrganisation'), ...new Mutations('xeroOrganisations') };
